import { Form } from 'antd';
import React, { useCallback, useEffect } from 'react';
import SimpleSelectStringTagsA10 from '../../components/SimpleSelectStringTagsA10';
import TaskSomethingForm from '../tasks/ViewTaskModal/TaskSomethingForm';

function ChangeTagsInnerModalUpgPA({
  adoption,
  saving,
  handleFinish,
  onCancel,
}) {
  const [form] = Form.useForm();
  useEffect(() => {
    if (adoption) {
      form.setFieldsValue({
        tags: adoption.tags,
      });
    }
  }, [adoption, form]);

  const _handleFinish = useCallback(
    async (_values) => {
      const { tags, ...values } = _values;
      handleFinish({
        tags,
        ...values,
      });
    },
    [handleFinish],
  );
  return (
    <TaskSomethingForm
      title="Edit Tags"
      form={form}
      onFinish={_handleFinish}
      onCancel={onCancel}
      saving={saving}
    >
      <Form.Item label="Tags" name="tags">
        <SimpleSelectStringTagsA10 disabled={saving} />
      </Form.Item>
    </TaskSomethingForm>
  );
}

export default ChangeTagsInnerModalUpgPA;
